import React, { useEffect, useState } from 'react';
import tapIcon from "../../../services/TapIcon";
import assetStyle from './AssetCard.module.css';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { toast } from 'react-toastify';
import HttpAPICall from '../../../services/HttpAPICall';
import { useSelector } from 'react-redux';


function EditNotes({asset_id, editNotes, refreshAssetDetail}) {

    const accessToken                   =   useSelector(state => state.auth.access_token);

    const [editIcon, setEditIcon]       =   useState(false);
    const [notes, setNotes]             =   useState('');
    const [btnDisable, setBtnDisable]   =   useState(false);

    useEffect(() => {
        if(editNotes) {
            setNotes(editNotes);
        }
    }, [])

    const handleEditBtn         =   ()  => {
        
        if(asset_id && notes !== editNotes) {
            setBtnDisable(pre => !pre);

            HttpAPICall.withAthorization('PUT', IAM_API_BASE_URL_2 + '/asset/' + asset_id , accessToken, null, {notes}, (res) => {
                toast.success(res.data.msg, {position: toast.POSITION.TOP_RIGHT});
                refreshAssetDetail(asset_id);
                // getAssetCardDetails(asset_id)
            }).then(() => { 
                setBtnDisable(pre => !pre);
                setEditIcon(pre => !pre);
            })
        }else {
            toast.error("Please, Edit your notes, same notes not accept.", {position: toast.POSITION.TOP_RIGHT});
        } 
    }

  return (
    <>
    <tr>
        <td className={[assetStyle.asset_card_details, 'py-3'].join(' ')}>Notes : {!editIcon && <span className='float-end' onClick={() => setEditIcon(pre => !pre)}><tapIcon.FontAwesomeIcon icon={tapIcon.faPencilAlt} alt="item-action" /></span>}  
        {
            editIcon ? 
            <>
            <textarea
                className="form-control mt-3"
                name="notes"
                // value={notes}
                rows="4"
                onChange={(e) => setNotes(e.target.value) }
                placeholder="Enter Notes"
                disabled={btnDisable}
            >{notes}</textarea>
            <button type="button" className="btn btn-sm btn-secondary my-2 float-end" disabled={btnDisable} onClick={handleEditBtn}>
                Edit 
                {/* <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" /> */}
            </button>
            </>
            : <div className="pt-2"><b>{notes}</b></div>
        }
        </td>
    </tr>
    </>
  )
}

export default EditNotes